// src/hooks/hotelRoomCategories/useForceDeleteAllHotelRoomCategories.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllHotelRoomCategories as forceDeleteAllHotelRoomCategoriesAPI } from "../../api/apiHotelRoomCategories";
import parseError from "../../utils/parseError";

const useForceDeleteAllHotelRoomCategories = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllHotelRoomCategoriesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel room categories permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected hotel room categories");
        },
    });

    return { forceDeleteAllHotelRoomCategories: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllHotelRoomCategories;
